<template>
  <CommonTabs
    v-bind:key="$route.params.id"
    :id="$props.id"
    resource="meter-units"
    :tabs="tabs"
    :components="components"
    :default-router="{ name: 'meter-units' }"
    :breadcrumbs="breadcrumbs"
    :tab.sync="tab"
  ></CommonTabs>
</template>

<script>
import CommonTabs from "../../../components/common/tabs/CommonTabs";
import EditMeterUnit from "../../../components/projects/metering/meter-units/EditMeterUnit";
import NewMeterUnit from "../../../components/projects/metering/meter-units/NewMeterUnit";
import DeleteMeterUnit from "../../../components/projects/metering/meter-units/DeleteMeterUnit";
import RecordsMeterUnit from "../../../components/projects/metering/meter-units/RecordsMeterUnit";
import LifeCycleMeterUnit from "../../../components/projects/metering/meter-units/LifeCycleMeterUnit";
import { projectTitle } from "../../../components/mixins/projects/projectTitle";
export default {
  name: "MeterUnit",
  mixins: [projectTitle],
  components: {
    CommonTabs
  },
  props: ["project_id", "id"],
  data: () => ({
    components: {
      EditMeterUnit,
      DeleteMeterUnit,
      RecordsMeterUnit,
      NewMeterUnit,
      LifeCycleMeterUnit
    },
    tab: 0
  }),
  computed: {
    tabs() {
      if (!this.$props.id) {
        return [
          {
            component: "NewMeterUnit",
            title: "create"
          }
        ];
      } else {
        return [
          {
            component: "EditMeterUnit",
            title: "edit"
          },
          {
            component: "RecordsMeterUnit",
            title: "records",
            tabClass: {
              "pl-0": true,
              "tab-item-full-width": true,
              "tab-item-padding-0": true
            }
          },
          {
            title: "life-cycle",
            component: "LifeCycleMeterUnit"
          },
          {
            component: "DeleteMeterUnit",
            title: "delete"
          }
        ];
      }
    },
    meterUnit: {
      get() {
        return this.$store.getters[
          "projectMeteringStore/meterUnitStore/getItem"
        ];
      }
    },
    meter() {
      return (
        this.$store.getters["projectMeteringStore/meterStore/getList"].find(
          i => i.id === this.meterUnit._meter.id
        ) || {}
      );
    },
    breadcrumbs() {
      return this.meterUnit.id
        ? [
            {
              text: this.$t("meter-units.meter-units"),
              to: {
                name: "meter-units",
                params: {
                  project_id: this.project.id
                }
              },
              exact: true
            },
            ...(this.meter._groups || []).map(i => ({
              text: i.name,
              to: {
                name: "group",
                params: {
                  project_id: this.project.id,
                  id: i.id
                }
              },
              exact: true
            })),

            {
              text: this.meter.name,
              to: {
                name: "meter",
                params: {
                  project_id: this.project.id,
                  id: this.meter.id
                }
              },
              exact: true
            },
            {
              text: this.meterUnit.name,
              to: {
                name: "meter-unit",
                params: {
                  project_id: this.project.id,
                  id: this.meterUnit.id
                }
              },
              exact: true
            }
          ]
        : [];
    }
  },
  watch: {
    meterUnit: function() {
      this.setTitle();
    },
    "$route.params.id"() {
      this.getMeterUnit();
    }
  },
  methods: {
    getArgumentForTitle() {
      return {
        chain: [
          this.$t("meter-units.meter-units"),
          this.$route.params.id
            ? this.meterUnit.name
            : this.$t("meter-units.create")
        ]
      };
    },
    getMeterUnit() {
      if (this.$route.params.id) {
        this.$store.dispatch("projectMeteringStore/meterUnitStore/get", {
          id: this.$route.params.id,
          project_id: this.$props.project_id
        });
      } else {
        this.$store.commit("projectMeteringStore/meterUnitStore/set", {
          item: {}
        });
      }
      this.tab = 0;
    }
  },

  mounted() {
    this.getMeterUnit();
  }
};
</script>
